import { formatMovie } from '../utils/movie';
import tvtApi from "../services/tvt-api";

export const MOVIE_REQUEST = 'MOVIE_REQUEST';
export const MOVIE_SUCCESS = 'MOVIE_SUCCESS';
export const MOVIE_ERROR = 'MOVIE_ERROR';

const requestMovie = movieId => ({
  type: MOVIE_REQUEST,
  movieId
});

export const loadMovie = fetchedMovie => ({
  type: MOVIE_SUCCESS,
  fetchedMovie
});

const errorMovie = error => ({
  type: MOVIE_ERROR,
  error
});

export const getMovieData = movieId => async dispatch => {
  dispatch(requestMovie(movieId));

  try {
    const movieData = await tvtApi.getMovieData(movieId);
    const movie = formatMovie(movieData);
    dispatch(loadMovie(movie));
  } catch (err) {
    dispatch(errorMovie(err));
  }
};
